import { render } from "./GalleryCardDescription.vue?vue&type=template&id=0d0730bf&scoped=true&ts=true"
import script from "./GalleryCardDescription.ts?vue&type=script&lang=ts"
export * from "./GalleryCardDescription.ts?vue&type=script&lang=ts"

import "./GalleryCardDescription.scss?vue&type=style&index=0&id=0d0730bf&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0730bf"]])

export default __exports__